import React from 'react';
import { TESTIDS } from '@/lib/testIds';
import { Bee, Gladiolus, HeartTrail, Sun, Sprig } from './Illustrations';

const BOOK_COVER = '/images/book-cover.jpg';

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" data-testid={TESTIDS.hero.section} className="relative overflow-hidden pt-10 md:pt-14 pb-24 md:pb-32">
      {/* soft washes */}
      <div className="absolute -top-24 -left-24 w-[520px] h-[520px] bg-[#FBE8EE] blob-shape-1 opacity-70" />
      <div className="absolute -bottom-24 right-[-120px] w-[480px] h-[480px] bg-[#F5C857]/25 blob-shape-2" />
      <Sun className="absolute top-24 right-8 md:right-24 w-20 md:w-28 opacity-90 animate-float-slow" />
      <Gladiolus className="absolute -left-6 top-24 w-32 md:w-44 opacity-90 hidden sm:block animate-drift" />
      <Sprig className="absolute right-12 bottom-24 w-40 opacity-80 hidden md:block" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left copy */}
          <div className="animate-fade-up">
            <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur px-4 py-2 rounded-full border border-white shadow-sm">
              <span className="text-[#F5C857]">✻</span>
              <span className="font-accent text-[#8D68B2] text-xl">a debut picture book</span>
            </div>

            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-[#24385C] mt-6 leading-[1.02]">
              <span className="block">Erica</span>
              <span className="block"><span className="squiggle-underline">Thayer</span></span>
            </h1>

            <p className="mt-6 font-body text-lg md:text-xl text-[#24385C]/75 max-w-lg">
              Children&rsquo;s Author <span className="text-[#B88ACB]">•</span> Former Educator
            </p>
            <p className="font-accent text-3xl md:text-4xl text-[#8D68B2] mt-2">
              Stories for growing hearts.
            </p>

            <p className="mt-8 font-body text-base md:text-lg text-[#24385C]/80 max-w-xl leading-relaxed">
              Gentle, hopeful stories that help children welcome big feelings with curiosity,
              compassion, and courage — and open meaningful conversations with the grown-ups who love them.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <button
                data-testid={TESTIDS.hero.buyBtn}
                onClick={() => scrollTo('book')}
                className="bg-[#8D68B2] hover:bg-[#24385C] text-white rounded-full px-8 py-4 font-body font-semibold shadow-md hover:shadow-xl transition-all hover:-translate-y-0.5"
              >
                Buy the Book
              </button>
              <button
                data-testid={TESTIDS.hero.meetBtn}
                onClick={() => scrollTo('about')}
                className="bg-[#F5C857] hover:bg-[#F1BE3E] text-[#24385C] rounded-full px-8 py-4 font-body font-semibold shadow-md hover:shadow-xl transition-all hover:-translate-y-0.5"
              >
                Meet Erica
              </button>
            </div>
          </div>

          {/* Right book art */}
          <div className="relative animate-fade-up" style={{ animationDelay: '150ms' }}>
            <div className="relative mx-auto max-w-md">
              {/* watercolor blob backdrop */}
              <div className="absolute inset-0 -m-8 bg-[#B88ACB]/30 blob-shape-3 blur-2xl" />
              <div className="absolute inset-0 -m-4 bg-[#A8B78C]/25 blob-shape-1" />

              <div className="relative rounded-[28px] bg-white shadow-[0_30px_60px_-20px_rgba(36,56,92,0.35)] p-3 rotate-[-3deg] hover:rotate-0 transition-transform duration-500">
                <img
                  src={BOOK_COVER}
                  alt="The Feelings Bench — a picture book by Erica Thayer"
                  data-testid={TESTIDS.hero.bookImage}
                  className="w-full h-auto rounded-2xl block"
                  loading="eager"
                />
              </div>

              {/* Floating bee with trail */}
              <div className="absolute -top-6 -right-4 md:-right-10 w-24 md:w-28 animate-float-tiny">
                <Bee className="w-full" />
              </div>
              <HeartTrail className="absolute -bottom-6 -left-6 w-40 opacity-80 hidden sm:block" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
